import React from "react";
import Table from "../../presenters/table";
import Skeleton from "react-loading-skeleton";

/**
 * Display a table with the performance of the client's portfolio
 * in different windows.
 * 
 * @param {} portfolio The backtested portfolio with the client's asset allocation 
 * @returns 
 * 
 * @author Giovanna Marinelli
 */
const PerformanceTable = ({ portfolio, portfolioExPandhora }) => {
  const formatPercentage = (val) => {
    return val ? (100*val).toFixed(2) + "%" : "0.00%";
  }
  return (
    <div className="PerformanceTable__container container">
      { portfolio && portfolioExPandhora ?
      <div className="table-responsive">
        <Table>
          <Table.Head>
            <Table.Tr>
              <Table.Th
                className="PerformanceTable__rowindex"
                scope="col"
              ></Table.Th>
              <Table.Th className="PerformanceTable__th" scope="col">
                Mês
              </Table.Th>
              <Table.Th className="PerformanceTable__th" scope="col">
                Ano
              </Table.Th>
              <Table.Th className="PerformanceTable__th" scope="col">
                3 meses
              </Table.Th>
              <Table.Th className="PerformanceTable__th" scope="col">
                6 meses
              </Table.Th>
              <Table.Th className="PerformanceTable__th" scope="col">
                12 meses
              </Table.Th>
              <Table.Th className="PerformanceTable__th" scope="col">
                Início
              </Table.Th>
            </Table.Tr>
          </Table.Head>
          <Table.Body>
            <Table.Tr>
              <Table.Th scope="row">Carteira com a Pandhora</Table.Th>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolio.returnMTD())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolio.returnYTD())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolio.return3M())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolio.return6M())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolio.return12M())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolio.returnSI())}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th scope="row">Sua carteira atual</Table.Th>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolioExPandhora.returnMTD())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolioExPandhora.returnYTD())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolioExPandhora.return3M())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolioExPandhora.return6M())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolioExPandhora.return12M())}</Table.Td>
              <Table.Td className="PerformanceTable__td">{formatPercentage(portfolioExPandhora.returnSI())}</Table.Td>
            </Table.Tr>
          </Table.Body>
        </Table>
      </div> : 
    <Skeleton count={5}></Skeleton>}
    </div>
  ) 
};

export default PerformanceTable;
